import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EventService {

  private listeners = [];
  public eventEmitter = new EventEmitter();

  constructor() { }

  emit(name: string, data: any) {
    console.log(name, 'emit');
    this.listeners.forEach(listener => {
      if (listener.name === name && listener.fn) {
        listener.fn(data);
      }
    });
  }

  on(name: string | string[], fn) {
    const indexes = [];
    if (Array.isArray(name)) {
      name.forEach(N => {
        indexes.push(this.listeners.length);
        this.listeners.push({ name: N, fn });
      });
    } else {
      indexes.push(this.listeners.length);
      this.listeners.push({ name, fn });
    }
    return () => {
      indexes.forEach(index => this.listeners.splice(index, 1));
    };
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/services/event/event.service.ts